import React, { useMemo } from 'react';
import { array, object, string } from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import AgencyInfo from './components/AgencyInfo';
import AddressInfo from './components/AddressInfo';
import BillingAddress from './components/BillingAddress';
import PaymentInfo from '../PaymentInfo';
import ConfirmationMessage from '../ConfirmationMessage';

const PaymentDetailsContent = ({
  paymentResultList, installments, agency, confirmationMsg, shippingAddress,
}) => {
  const isShowShippingSection = useMemo(() => !isEmpty(shippingAddress), [ shippingAddress ]);
  return <div className="payment-details-content">
    {
      isShowShippingSection
    && <div className="external-info__address-info">
      <AddressInfo addressInfo={shippingAddress} title={'checkout.lib.components.text.shippingAdress'}/>
    </div>
    }
    <div className="payment-details-content__external-info">
      <PaymentInfo paymentResultList={paymentResultList} installments={installments} agency={agency}/>
      <BillingAddress paymentResultList={paymentResultList} />
    </div>
    {paymentResultList.length > 0 && (!!confirmationMsg || Object.keys(agency).length > 0) && <div className="hr-solid-line" />}
    <ConfirmationMessage confirmationMsg={confirmationMsg}/>
    <AgencyInfo agency={agency}/>
  </div>;
};

PaymentDetailsContent.propTypes = {
  paymentResultList: array,
  installments: array,
  agency: object,
  confirmationMsg: string,
};

PaymentDetailsContent.defaultProps = {
  paymentResultList: [],
  installments: [],
  agency: {},
};

export default PaymentDetailsContent;
